import { render, staticRenderFns } from "./RecordsListRow.vue?vue&type=template&id=dc6de7be"
import script from "./RecordsListRow.vue?vue&type=script&lang=js"
export * from "./RecordsListRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports